export const bodyDarkModeClass = 'dark'
export const forceDarkModeClass = 'dark'
export const letterSectionAttribute = 'data-letter-section'
